import React from 'react';
import { useTranslation } from 'react-i18next';
import { SrOnly } from '../../styled-components/components/SrOnly';

interface TagItemProps {
  title: string;
  isExcluded?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onRemove?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TagItem = ({ title, isExcluded, onClick, onRemove }: TagItemProps) => {
  const { t } = useTranslation(['search', 'validation']);

  let tagTitle = <>{title || t('valueMissing', { ns: 'validation' })}</>;
  if (isExcluded) {
    tagTitle = (
      <>
        <i className="icon-minus m-r-mini" />
        {title}
      </>
    );
  }

  return (
    <div className={`filter${isExcluded ? ' is-excluded' : ''}`}>
      {onClick ? (
        <button
          type="button"
          className="filter-action"
          onClick={onClick}
          title={t('changeSpecificFilter', { name: title, ns: 'search' })}
        >
          {tagTitle}
        </button>
      ) : (
        <div className="filter-action">{title}</div>
      )}

      {onRemove && (
        <button
          type="button"
          className="filter-action is-remove"
          onClick={onRemove}
          title={t('removeSpecificFilter', { name: title, ns: 'search' })}
        >
          <i className="icon-close no-margin" />
          <SrOnly>{t('removeSpecificFilter', { name: title, ns: 'search' })}</SrOnly>
        </button>
      )}
    </div>
  );
};

export default TagItem;
